<template>
  <el-dialog
    id="popup_dialog"
    :title="titlu"
    :visible.sync="showPopup"
    class="my-dialog-class custom-width"
    :destroy-on-close="true"

  >
    <el-tooltip placement="bottom-end"  effect="light">
      <div slot="content">Se pot alege toti angajatii sau doar cate unul<br/>Daca nu se bizeaza "Toata ziua" atunci nu se pot face programari in ziua si intervalul selectat.</div>
      <i class="el-icon-info" style="font-size: 17px;color:#409EFF"></i>
    </el-tooltip>

    <div class="container">
      <el-form
        label-position="top"
        :inline="false"
        :rules="rules"
        label-width="100%"
        :model="selectedObject"
        ref="my-form"
        @submit.prevent="save"
        v-loading="loadingVisible"
      >
        <el-row :gutter="15">
          <el-col :md="8">
            <el-form-item label="Denumire" prop="Denumire">
              <el-input class="full-width" v-model="selectedObject.Denumire" />
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="Utilizator" prop="IdUtilizator">
              <el-select class="full-width" v-model="selectedObject.IdUtilizator" filterable>
                <el-option label="Toti" value="-1"></el-option>
                <el-option
                  v-for="item in Info.utilizatori"
                  :key="'utilizatori' + item.Id"
                  :label="item.Nume"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label='Ziua' prop="ZiLibera">
                <el-date-picker                            
                    v-model="selectedObject.ZiLibera"
                    type="date"
                    :picker-options="datePickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
          </el-col> 
          
          <el-col :md="8">
            <el-form-item label="Toata ziua">
              <el-checkbox
                v-model="selectedObject.ToataZiua"
                true-label="1"
                false-label="0"
              >
               Toata ziua
              </el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :md="8" v-if="!Boolean(Number(selectedObject.ToataZiua))" >
            <el-form-item label='Interval orar' prop="IntervalOrarLiber">
              <el-time-picker
              style="width: 45% !important;"
                  :disabled="Boolean(Number(selectedObject.ToataZiua))" 
                  size="small"
                  v-model="selectedObject.IntervalOrarLiber[0]"
                  value-format = "HH:mm:00"
                  format = "HH:mm"
                 :clearable="false"         
                /> - <el-time-picker
                 style="width: 45% !important;"
                  :disabled="Boolean(Number(selectedObject.ToataZiua))" 
                  size="small"
                  v-model="selectedObject.IntervalOrarLiber[1]"
                  value-format = "HH:mm:00"
                  format = "HH:mm"
                  :clearable="false"    
                />
            </el-form-item>
          </el-col> 

          
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>

      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "",
  extends: BasePage,
  data() {
    var ore = (rule, value, callback) => {
      if (this.selectedObject.ToataZiua !== "1" && 
        (this.selectedObject.IntervalOrarLiber[0] == null ||
         this.selectedObject.IntervalOrarLiber[0] == ""   ||
         this.selectedObject.IntervalOrarLiber[1] == null ||
         this.selectedObject.IntervalOrarLiber[1] == ""
        )) {
        callback(new Error("Campul este obligatoriu"));
      } else {
        callback();
      }
    };
    return {
      datePickerOptions: {firstDayOfWeek: 1},
      baseUrl: "",
      showPopup: false,
      titlu: "",
      mode: "add",
      selectedObject: {
        Denumire: "",
        IntervalOrarLiber:["09:00:00", "19:00:00"],
        ToataZiua: 0,
      },
      Info: {},
      rules: {
        Denumire: [{ required: true, message: "Campul este obligatoriu" }],
        IdUtilizator: [{ required: true, message: "Campul este obligatoriu" }],
        ZiLibera: [{ required: true, message: "Campul este obligatoriu" }],
        IntervalOrarLiber: [{ validator: ore }],
      },
    };
  },
  methods: {
    show_me: async function (id) {
      
      if (id == null) {
        this.mode = "add";
        this.titlu = "Adauga o zi libera";
        this.selectedObject = { Denumire: "" , IntervalOrarLiber:["09:00:00", "19:00:00"], ToataZiua: 0,};
      } else {
        this.mode = "edit";
        this.titlu = "Editeaza o zi libera";
        var result = await this.post("utilizatori/get_info_item_dialog_zile_libere", {
          id: id,
        });
        this.selectedObject = result.Item;
        
        if(this.selectedObject.IntervalOrarLiber == null ) this.selectedObject.IntervalOrarLiber= ["09:00:00", "19:00:00"];

      }
      this.showPopup = true;
    },



    async get_info() {
      var response = await this.post("utilizatori/get_info_for_dialog_zile_libere");
      this.Info.utilizatori = response.utilizatori;
    },
    async resetObject(){
      // this.selectedObject = { Nume: "" };
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          try {
            await this.post("utilizatori/save_zile_libere", {
              mode: this.mode,
              object: this.selectedObject,
            });
            this.selectedObject = { Denumire: "" , IntervalOrarLiber:["09:00:00", "19:00:00"], ToataZiua: 0,};
            this.$message({type: 'success', message: 'Ziua libera a fost adaugata cu succes!'});  
            this.$emit("save");
          } catch (error) {
            this.$message({type: 'error', message: 'A intervenit o problema in adaugarea zilei libere!'});  
          }finally{
            this.showPopup = false;
          }
          
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less">
#popup_dialog {
  .full-width {
    width: 100% !important;
  }

  .container {
    width: 100% !important;
  }

  @media only screen and (max-width: 600px) {
    .el-dialog{
      min-width: 90vw !important;
    }
  }
}
</style>